"use client";
import Image from "next/image";
import Link from "next/link";
import React, { useState } from "react";

const ReadMore = ({ children }) => {
  const text = children;
  const [isReadMore, setIsReadMore] = useState(true);

  // Toggle the Read More state
  const toggleReadMore = () => {
    setIsReadMore(!isReadMore);
  };

  // rohailjohn
  return (
    <>
      <div
        className={`${isReadMore ? "line-clamp-5" : ""} overflow-hidden`}
        style={{
          display: "-webkit-box",
          WebkitBoxOrient: "vertical",
          textOverflow: "ellipsis",
          whiteSpace: "normal",
        }}
      >
        {/* {text} */}
        <p
          dangerouslySetInnerHTML={{ __html: text }}
          className="updatedparapremu pt-6"
        ></p>
      </div>
      {text.length > 380 && (
        <div
          onClick={toggleReadMore}
          className="style-redmore"
          style={{
            color: "#D5AF34",
            fontSize: "17px",
            display: "inline-block",
            marginLeft: "1px",
            cursor: "pointer",
          }}
        >
          {isReadMore ? "Read More" : "Show less"}
        </div>
      )}
    </>
  );
};
function mia({ Mydata }) {
  const data = Mydata[4];
  return (
    <div>
      <div className="mx-auto px-6 pt-10 max-w-7xl grid grid-cols-5  lg:gap-10 mb-7">
        <div className="flex-auto col-span-12 sm:col-span-12 md:col-span-12 lg:col-span-2">
          <Image
            src={data.image}
            height={400}
            width={1200}
            alt={data.alt}
            title={data.tle}
            loading="lazy"
          />
        </div>
        <div className="mb-4 col-span-12 sm:col-span-12 md:col-span-12 lg:col-span-3">
          <h2 id="visionh2" className="text-3xl  secondary font-bold mb-3 ">
            {data.title}
            <span className="text-[#D5AF34]">{data.subtitle}</span>
          </h2>
          <div
            dangerouslySetInnerHTML={{ __html: data?.des }}
            className="updatedparapremu"
          ></div>
        </div>
      </div>
    </div>
  );
}

export default mia;
